import React, { useEffect, useState } from "react"
import { Navigate } from "react-router-dom"
import axios from "axios"
import { useSelector } from "react-redux"
import config from "../../config/config"
import { Spinner } from "reactstrap"

const Authmiddleware = props => {
  const [isAuthenticated, setIsAuthenticated] = useState(null)

  // Access the userData from Redux store using useSelector
  const userData = useSelector(state => state.Login.userData)

  useEffect(() => {
    const validateToken = async () => {
      // If userData or token does not exist in Redux, mark user as not authenticated
      if (!userData || !userData.token) {
        setIsAuthenticated(false)
        return
      }

      try {
        const response = await axios.post(
          `${config.backendUrl}/auth/validateToken`,
          { token: userData.token },
        )

        if (response.data.valid) {
          setIsAuthenticated(true)
        } else {
          setIsAuthenticated(false)
        }
      } catch (error) {
        console.error("Token validation failed", error)
        setIsAuthenticated(false)
      }
    }

    validateToken()
  }, [userData])

  if (isAuthenticated === null) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0)", // Add background color with opacity
        }}
      >
        <Spinner
          color="primary"
          style={{
            height: "3rem",
            width: "3rem",
          }}
        >
          Loading...
        </Spinner>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />
  }

  return <>{props.children}</>
}

export default Authmiddleware
